module.exports = __webpack_public_path__ + "static/media/users.1c804276.svg";